import { render } from "./NumberListSort.vue?vue&type=template&id=00afe4bd&ts=true"
import script from "./NumberListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/number/components/NumberListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00afe4bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00afe4bd', __exports__)) {
    api.reload('00afe4bd', __exports__)
  }
  
  module.hot.accept("./NumberListSort.vue?vue&type=template&id=00afe4bd&ts=true", () => {
    api.rerender('00afe4bd', render)
  })

}


export default __exports__